import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./shared/styles/shared.scss";

import { BrowserRouter, Routes, Route, redirect } from "react-router";
import Calendar from "./pages/Сalendar/Calendar";
import Main from "./pages/Main/Main";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { backUrl} from "./shared/shared";
import Login from "./pages/Login/Login";
import axios from "axios";
import GameInfo from "./pages/GameInfo/GameInfo";
import LocationMeet from "./pages/locationMeet/LocationMeet";
import NotImplemented from "./pages/NotImplemented/NotImplemented";
import App from "./App";
import { ToastContainer, Slide } from "react-toastify";
import Cabinet from "./pages/Cabinet/Cabinet";
import { clearUserData, redirectToLogin } from "./pages/Login/services/authService";

export const qClient = new QueryClient({});

axios.defaults.baseURL = backUrl;

// Перехватчик запросов для добавления JWT токена
axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {

    if (
      error.status == 401 ||
      (error.status == 403 &&
        error.response?.data?.detail?.includes("CSRF Failed"))
    ) {
      clearUserData() // Не вставить ли жту функицю внутрь redirectToLogin...
      redirectToLogin()
    }
    return Promise.reject(error);
  }
);

export const routes = [
  { path: "/calendar", element: <Calendar /> },
  { path: "/register", element: <Login registerPage /> },
  { path: "/", element: <Calendar /> },
  { path: "/login", element: <Login /> },
  { path: "/promo", element: <Main /> },
  { path: "/gameInfo", element: <Calendar /> },
  { path: "/locationMeet", element: <Calendar /> },
  { path: "/locationMeet/:guID", element: <LocationMeet /> },
  { path: "/gameInfo/:guID", element: <GameInfo /> },
  { path: "/cabinet", element: <Cabinet /> },
  { path: "/cabinet/:guID", element: <Cabinet /> },
];
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={qClient}>
      <BrowserRouter>
        <App />
        <ToastContainer
          transition={Slide}
          style={{ marginRight: "8px", zIndex: 100000 }}
          autoClose={false}
          draggable
          draggablePercent={40}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
